import type { FaireProductEntity } from "../../entity_types/product";

export const p_3yckw39v8d: FaireProductEntity = {
  token: "p_3yckw39v8d",
  type: "product",
  name: "Oversized Knit Hooded Cardigan",
  brandToken: "b_qcqvf6ftyr",
  brandName: "AZSHOP Trading LLC",
  imageUrl:
    "https://cdn.faire.com/fastly/5c6556a811fcc92bdfa85a5efdcb7f284cc13b9d470090cdb0aaf2e33b5f6224.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/659ff9f4e2d7b20c91090a0e73f5b530eeb6dd81f39d8b1c66bea25b83e5b1de.jpeg",
    "https://cdn.faire.com/fastly/ad385916024f9576b6f8e5b574ef93497283d129332e0c69c6d9f4aa908b70a8.jpeg",
    "https://cdn.faire.com/fastly/c11f1cf3307bc73b2dbc03b5d5ad6071be7b5ea6d6c438268fb254c0b1ed69ea.jpeg",
    "https://cdn.faire.com/fastly/02caa3218621ef0f9c28796eac35d0bb7d92d809062d086a6884b0d9bbd18b23.jpeg",
    "https://cdn.faire.com/fastly/a63491d21614f941b5ad5561beb57f3efba3695df58cf22fbd46fdc2ee02a04b.jpeg",
    "https://cdn.faire.com/fastly/0b883bd9a1ae8129611e084770b8760001f12a5d06fabde57168feb15e13c34f.jpeg",
    "https://cdn.faire.com/fastly/603849f9b6092c487d95a18f6b4a49515748cb74fe7405ac0476783e152cae9b.jpeg",
    "https://cdn.faire.com/fastly/b3f7aee981d3fe59af3b44f5aeabd4146cd38764db935286843286051d401378.jpeg",
    "https://cdn.faire.com/fastly/8e49084f99e0dab4d32a6f327a8b6c01bfa8f5b14027bf10b04241194e3b3f66.jpeg",
    "https://cdn.faire.com/fastly/fe3ef51b6b8ee9e9cc54e03fe79c204b2badd19ca9d690cb6f11ee1c5ad965dc.jpeg",
    "https://cdn.faire.com/fastly/147f0b6b9ebe6838a8a0ec5164735a7f34bc299f97d4d795a4f8de7292e71c9b.jpeg",
    "https://cdn.faire.com/fastly/1e6f2d9daec3fdddd34e0185ef2a35884eb4761a4681be23299f5474339e8097.jpeg",
    "https://cdn.faire.com/fastly/c6ecd03a9fb3e8c21a2937962a44f81d2aa5505e801b383526c3cc4c4325654d.jpeg",
    "https://cdn.faire.com/fastly/4c8994bfbeaaf67c22f762b9a2740fdb835a2de4ea0e360119b1f70be1f14429.jpeg",
    "https://cdn.faire.com/fastly/d8c4d6c2c58d5d6ba681a86c8eb424b02f3ea980a4dd01988ebb25257ebcca78.jpeg",
    "https://cdn.faire.com/fastly/9eba6ecea1896335db893b80ca005a303a67fbd41d6ab0dddd0b65dd01f8004a.jpeg",
    "https://cdn.faire.com/fastly/be4d009018564d1fe407c868148a690a8ee12587d524ff22ad5413c35127ffee.jpeg",
    "https://cdn.faire.com/fastly/1da043c4834d24023bead702c576562faa43e6a4a68c917da9e2cbd6a6a3d7ad.jpeg",
    "https://cdn.faire.com/fastly/c7904c5e7ef602b861229f263c0753309a793196ece7073bc31183367b351aa6.jpeg",
    "https://cdn.faire.com/fastly/4b84d7a1cb4b8ca090ccbe3bed35542e6eec84cb34ccb2009ded4ebc9c4e6395.jpeg",
    "https://cdn.faire.com/fastly/4d3601871143841de1dbdb50bfb543b345562d0b1e52c7eb66485b484cdd3dc1.jpeg",
    "https://cdn.faire.com/fastly/2c6911a30207f7704db8fa1d8bdbf925d6d9eaebea0c954197078826acd46ef1.jpeg",
    "https://cdn.faire.com/fastly/4079d6ca5b0324e026946b16b851baf640d485412d0e16b3f246a1016d263afb.jpeg",
  ],
  priceDollars: 37.4,
  description:
    "Oversized hooded cardigan with a chunky knit. Features open front and long sleeves, perfect for cozy layering.\n\nFabric: 52% acrylic,28% nylon,20% PBT\nWeight: 1.98 lb",
  tags: [],
  msrpDollars: 74.8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:24:24.577Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
